export enum MiniGameStatus {
    future = 'future',
    active = 'active',
    past = 'past',
}

export type MiniGameDataForAdmin = {
    id: string;
    title: string;
    link: string;
    imageUrl?: {
        original: string;
        small: string;
        medium: string;
        large: string;
    };
    setNumber: number;
    startDate: number;
    endDate: number;
    status: MiniGameStatus;
};

export type MiniGameSetDataForAdmin = {
    setNumber: number;
    games: MiniGameDataForAdmin[];
};
